import React from 'react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  tone?: 'light' | 'dark';
};
export function SectionCta({
  label,
  tone = 'light'
}: SectionCtaProps) {
  return <div className="mx-auto mt-12 w-full max-w-xl" data-id="element-278" data-mp="3ie89nfy8tuu7">
      <CtaButton label={label} data-id="element-279" data-mp="3ifjbha84osio" />
      <p className={`mt-3 text-center text-sm ${tone === 'dark' ? 'text-white/70' : 'text-muted'}`} data-id="element-280" data-mp="3nc9v27j5668u">
        One-time payment of USD $27 · Immediate access · 7-Day Guarantee
      </p>
    </div>;
}